import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { sortBy } from "lodash";
import config, { productSorting } from "../../../../config";
import elasticSearchApiService from "../../../services/elasticSearchApiService";

const SelectBox = ({ value, setValue, fieldName }) => {
  const { t } = useTranslation();
  const [categoryList, setCategoryList] = useState([]);
  useEffect(() => {
    elasticSearchApiService
      .fetchUniqueFieldValues(fieldName)
      .then(setCategoryList);
  }, [fieldName]);

  const sortedParent = sortBy(
    categoryList,
    p => productSorting[config.appLanguage][p]
  );

  return (
    <div className="u-form-select p-search__select">
      <select
        name="select-category"
        value={value}
        onChange={e => setValue(e.target.value)}
      >
        <option value="">{t("Select Category")}</option>
        {sortedParent.map(c => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectBox;
